import { useContext, useEffect, useState } from "react";
import organizationService from "../Services/organization.service";
import { Organization } from "../Interface/Index";
import LoaderContext from "../Context/LoaderContext/Index";

const useOrganization = () => {
  const { isLoading, setLoading } = useContext(LoaderContext);
  const [organization, setOrganization] = useState<Organization | null>(null);
  const fetchOrg = async () => {
    try {
      setLoading(true);
      const organizationData = await organizationService.getOrganizationData();
      if (organizationData) {
        setOrganization(organizationData);
        document.title = organizationData.orgName
          ? `${organizationData.orgName} | QualifyMe`
          : "Candidate | QualifyMe";
        setLoading(false);
      } else {
        console.error("Error: Organization data is null");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching organization data:", error);
    }
  };

  useEffect(() => {
    fetchOrg();
  }, []);

  return {
    organization,
  };
};

export default useOrganization;
